import { useEffect, useState } from 'react';
import { getLeaderboard } from '../services/api';

/** Loads the leaderboard, refetching whenever the sort changes. */
export function useLeaderboard({ limit, sortBy, sortDir }) {
  const [state, setState] = useState({ data: null, loading: true, error: null });

  useEffect(() => {
    const controller = new AbortController();
    // Keep the previous rows on screen while the new sort loads.
    setState((current) => ({ ...current, loading: true, error: null }));

    getLeaderboard({ limit, sortBy, sortDir, signal: controller.signal })
      .then((data) => setState({ data, loading: false, error: null }))
      .catch((error) => {
        if (error.name === 'AbortError') return;
        setState({ data: null, loading: false, error: error.message });
      });

    return () => controller.abort();
  }, [limit, sortBy, sortDir]);

  return state;
}
